/** Research guide §5 — Reviewing the long-list (`research/ResearchReviewView.tsx`). */
import { helpSectionMeta } from '../help-sections.js';
import {
  Btn,
  Bullets,
  HelpSectionCard,
  Li,
  P,
  SectionLink,
  Shot,
  SubHead,
} from '../HelpPrimitives.js';

export function ResearchReview(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('research-review')}>
      <Shot
        slug="research-review"
        caption="The long-list review table: score, grade, evidence and per-row Accept/Reject."
      />
      <P>
        A table of every company on the long-list — rank, name, score, grade, a breakdown of how the
        score was built, and the evidence behind it. Filter by grade or status, or sort by score.
      </P>

      <SubHead>Working through the list</SubHead>
      <Bullets>
        <Li>
          <Btn>Accept</Btn> / <Btn>Reject</Btn> per row.
        </Li>
        <Li>Click a company&rsquo;s grade chip to change it (A/B/C).</Li>
        <Li>
          <Btn>Evidence</Btn> opens the sources and quotes behind that company&rsquo;s facts.
        </Li>
        <Li>
          A row the AI couldn&rsquo;t confidently place shows its own <Btn>Verify</Btn> button — a
          manual re-check, same rule as the AI chain: it only runs when you click it.
        </Li>
        <Li>
          <Btn>Add company</Btn> or <Btn>Bulk add</Btn> to bring in companies the automatic search
          missed.
        </Li>
      </Bullets>

      <P>
        The footer button is either <Btn>Continue to publish</Btn> (a specialist finishes the review
        and opens the Publish screen — the companies are sent to the recruiter only from there) or{' '}
        <Btn>Publish</Btn> directly, depending on the review-gate mode an admin has set — see{' '}
        <SectionLink to="research-publish">Publishing results</SectionLink>.
      </P>
    </HelpSectionCard>
  );
}
